<template>  
  <v-flex v-if="infosSimMission.param.enable_science_files && (infosSimMission.result.simulation_state == 'finished' || infosSimMission.result.simulation_state == 'aborted')" xs12 py-4 pr-4 pl-2 style="position:relative;" >
      <v-card class="maincontent" >
        <v-card-title style="flex-direction:column;align-items:stretch;height:100%;" >            
            <template>
              <v-layout row wrap mt-2 style="flex:0 0 auto;" >
                <v-flex class="centercontent" xs6 pr-2><span class="body-2">{{$t('Pilot.FileTransfert.Cycle')}}</span></v-flex>
                <!-- <v-flex class="centercontent" xs4 pl-2 pr-2 ><span class="body-2">{{$t('Pilot.FileTransfert.NavFieldName')}}</span><v-btn small icon @click="downloadFile(`/api/gliderfilevirtual/download/gli/${infosSimMission.id}/all`)" ><v-icon>mdi-download</v-icon></v-btn></v-flex> -->
                <v-flex class="centercontent" xs6 pl-2 ><span class="body-2">{{$t('Pilot.FileTransfert.PldFieldName')}}</span><v-btn small icon @click="downloadFile(`/api/gliderfilevirtual/download/pld1/${infosSimMission.id}/all`)"><v-icon>mdi-download</v-icon></v-btn></v-flex>
              </v-layout>            
              <v-layout row wrap style="flex:1 0;overflow:auto;align-content:flex-start;">
                <template v-for="yo in infosSimMission.mission.yoArray">
                  <v-flex class="centercontent" :key="`cycle_${yo.yosCycle}`" xs6 pr-2>{{yo.yosCycle}}</v-flex>
                  <!-- <v-flex class="centercontent" :key="`nav_${status.yosCycle}`" xs4 pl-2 pr-2 >                  
                    <v-btn small icon @click="downloadFile(`/api/gliderfilevirtual/download/gli/${infosSimMission.id}/${status.yosCycle}`)">
                      <v-icon>mdi-download</v-icon>
                    </v-btn>                    
                  </v-flex> -->
                  <v-flex class="centercontent" :key="`pld_${yo.yosCycle}`" xs6 pl-2 >
                    <v-btn small icon  @click="downloadFile(`/api/gliderfilevirtual/download/pld1/${infosSimMission.id}/${yo.yosCycle}`)">
                      <v-icon>mdi-download</v-icon>
                    </v-btn>                    
                  </v-flex>                              
                </template>
              </v-layout> 
            </template>            
        </v-card-title>
      </v-card>      
    </v-flex>
    <div v-else ref="container" style="width:100%;display:flex;flex:1 1 auto;flex-direction:column">
      <span class="display-2" style="margin:auto">{{(infosSimMission.result.simulation_state == 'finished' || infosSimMission.result.simulation_state == 'aborted')?$t('Pilot.FileTransfert.NotActivated'):$t('Pilot.FileTransfert.NoDataAvailable')}}        </span>
    </div>    
</template>
<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'
import { MapUiState } from '@/models/ui/MapUiState'
import { SimulationUiState, buildSimulationUIStateId } from '@/models/ui/SimulationUiState'
import apiHelpers from '@/utils/api'

@Component({
  name: 'SimulationDetailFileTransfert',
  props: {
    isleft:Boolean,
    uiid:{
        type: String,
        required: true
    }
  }
})
export default class SimulationDetailFileTransfert extends Vue {      

  isleft!:boolean
  uiid!:string

  get simUiid()
  {
    return `${this.uiid}_${this.bestFitMisId}`
  }


  get missionGlobal(){
   return this.$store.myGetters.originalAdmMissionGlobal
 }

  get simulation_uiid() {
    return buildSimulationUIStateId(this.missionGlobal.MIG_ID!,"detail")
  }

  get simulationState() { 
    //retourne un MapUiState    
    return this.uistatebyuiid(this.simulation_uiid) as SimulationUiState         
  }

  get missionVirtualsById(){
   return this.$store.myGetters.missionVirtualsById
 }

  get infosSimMission() {
    return this.missionVirtualsById[this.bestFitMisId]
  }

  get map_uiid(){
   return buildSimulationUIStateId(this.missionGlobal.MIG_ID!,'map')
 }

 get mapState() { 
   //retourne un MapUiState    
   return this.uistatebyuiid(this.map_uiid) as MapUiState         
 }

 get bestFitMisId(){
   return this.mapState?.bestFitMisId
 }

  get uistatebyuiid(){
    return this.$store.myGetters.uistatebyuiid
  }  

  downloadFile(url:string){
        apiHelpers.downloadFile(url,'.csv')
    }


  }
</script>